<template>
  <div class="help-bar">
    <div class="help-switch">
      <div class="help-icon">?</div>
      <div class="help-center">{{ $t("help_center") }}</div>
      <div :class="helpFlag ? 'close-help-button' : 'open-help-button'" @click="toggerBar"></div>
      <div class="togger-help" @click="toggerBar">{{ $t("help_show_hide") }}</div>
    </div>
    <div v-show="helpFlag" class="help-content">
      <el-scrollbar ref="scroll" class="frame-scrollbar">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div ref="helpContent" v-html="$t(helpContent)" />
      </el-scrollbar>
    </div>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <!-- <div
      v-show="helpFlag"
      ref="helpContent"
      class="help-content"
      v-html="$t(helpContent)"
    /> -->
  </div>
</template>
<script>
import { logWithPrefix } from "@/plugins/logging";
const log = logWithPrefix("[components/form/helpBar.vue]");
export default {
  props: {
    helpContent: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      helpFlag: false,
    };
  },
  methods: {
    toggerBar() {
      this.helpFlag = !this.helpFlag;
    },
    // jumpTohelp(tag) {
    //   if (!this.helpFlag) {
    //     return false
    //   }

    //   log(this.$refs)
    //   log(Object.values(this.$refs.helpContent.children))
    //   const objs = Object.values(this.$refs.helpContent.children).filter(
    //     (o) => {
    //       return o.name === tag
    //     }
    //   )
    //   if (objs && objs.length) {
    //     const scrollTop = objs[0].offsetTop
    //     this.$refs.helpContent.scrollTop = scrollTop - 10
    //   }
    // },
    jumpTohelp(tag) {
      if (!this.helpFlag) {
        return false;
      }

      log(this.$refs);
      log(Object.values(this.$refs.helpContent.children));
      const objs = Object.values(this.$refs.helpContent.children).filter((o) => {
        return o.name === tag;
      });
      if (objs && objs.length) {
        const scrollTop = objs[0].offsetTop;
        this.$refs.scroll.wrap.scrollTop = scrollTop - 10;
      }
    },
  },
};
</script>
<style lang="scss">
@import "~@/styles/variables.scss";
.help-bar {
  position: absolute;
  bottom: 0;
  width: calc(100% - 20px);
  z-index: $pageHelpBarZIndex;
  font-size: $helpFontSize;
  font-family: $helpFontFamily;
  color: $helpFontColor;
  b,
  h2 {
    color: $helpBoldColor;
  }
  font > b {
    font-size: $helpTitleFontSize;
    font-weight: 500;
  }
}
.help-switch {
  background-color: $helpBarBgColor;
  width: 100%;
  height: 30px;
}

.open-help-button {
  width: 0;
  height: 0;
  cursor: pointer;
  position: absolute;
  z-index: $pageHelpBarZIndex + 1;
  top: 8px;
  right: 50%;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 12px solid #fff;
}
.close-help-button {
  width: 0;
  height: 0;
  cursor: pointer;
  position: absolute;
  z-index: $pageHelpBarZIndex + 1;
  top: 8px;
  right: 50%;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 12px solid #fff;
}

.help-icon {
  height: 22px;
  width: 22px;
  cursor: pointer;
  background-color: #fff;
  font-size: 20px;
  text-align: center;
  border-radius: 100%;
  font-size: 14px;
  color: $helpIconColor;
  margin: 4px 5px;
  float: left;
  font-weight: bold;
  line-height: 24px;
}

.help-center {
  line-height: 30px;
  font-size: 16px;
  color: $helpFontColor;
  float: left;
}

.togger-help {
  cursor: pointer;
  float: right;
  color: $helpFontColor;
  font-size: $helpBarFontSize;
  font-style: $helpBarFontStyle;
  text-decoration: underline;
  line-height: 30px;
  margin-right: 10px;
}

.help-content {
  position: absolute;
  bottom: 30px;
  left: 0;
  height: 120px;
  width: calc(100% - 12px);
  z-index: $pageHelpBarZIndex;
  overflow: auto;
  background: $helpBgColor;
  color: $helpFontColor;
  padding: 6px;
}
.orbi.gui-2-1 {
  .help-switch {
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
  }
}
</style>
